import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MeetingProvider,
  useMeeting,
  useParticipant,
  Constants,
} from "@videosdk.live/react-sdk";
import ReactPlayer from "react-player";
import Hls from "hls.js";

function ParticipantView(props) {
    const micRef = useRef(null);
    const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName } =
      useParticipant(props.participantId);
    const videoStream = useMemo(() => {
      if (webcamOn && webcamStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(webcamStream.track);
        return mediaStream;
      }
    }, [webcamStream, webcamOn]);
    useEffect(() => {
      if (micRef.current) {
        if (micOn && micStream) {
          const mediaStream = new MediaStream();
          mediaStream.addTrack(micStream.track);
          micRef.current.srcObject = mediaStream;
          micRef.current
            .play()
            .catch((error) =>
              console.error("videoElem.current.play() failed", error)
            );
        } else {
          micRef.current.srcObject = null;
        }
      }
    }, [micStream, micOn]);  
    return (
      <div>
        <audio ref={micRef} autoPlay playsInline muted={isLocal} />
        {webcamOn && (
          <ReactPlayer
            playsinline // very very imp prop
            pip={false}
            light={false}
            controls={false}
            muted={true}
            playing={true}
            url={videoStream}
            height={"300px"}
            width={"300px"}
            onError={(err) => {
              console.log(err, "participant video error");
            }}
          />
        )}
      </div>
    );
    }

    function ViewerView() {
        // States to store downstream url and current HLS state
        const playerRef = useRef(null);
        //Getting the hlsUrls
        const { hlsUrls, hlsState } = useMeeting();
        //Playing the HLS stream when the downstreamUrl is present and it is playable
        useEffect(() => {
          if (hlsUrls.downstreamUrl && hlsState == "HLS_PLAYABLE") {
            if (Hls.isSupported()) {
              const hls = new Hls({
                capLevelToPlayerSize: true,
                maxLoadingDelay: 4,
                minAutoBitrate: 0,
                autoStartLoad: true,
                defaultAudioCodec: "mp4a.40.2",
              });
              let player = document.querySelector("#hlsPlayer");
              hls.loadSource(hlsUrls.downstreamUrl);
              hls.attachMedia(player);
            } else {
              if (typeof playerRef.current?.play === "function") {
                playerRef.current.src = hlsUrls.downstreamUrl;
                playerRef.current.play();
              }
            }
          }
        }, [hlsUrls, hlsState, playerRef.current]);
        return (
          <div>
            {/* Showing message if HLS is not started or is stopped by HOST */}
            {hlsState != "HLS_PLAYABLE" ? (
              <div id="not-live-msg">
                <p>RCC Montana is not live at the moment</p>
              </div>
            ) : (
              hlsState == "HLS_PLAYABLE" && (
                <div>
                  <video
                    ref={playerRef}
                    id="hlsPlayer"
                    autoPlay={true}
                    controls
                    style={{ width: "100%", height: "100%" }}
                    playsinline
                    playsInline
                    muted={true}
                    playing
                    onError={(err) => {
                      console.log(err, "hls video error");
                    }}
                  ></video>
                </div>
              )
            )}
          </div>
        );
        }

const StreamViewer = () => {
  return(
    <div>
        <MeetingProvider
        config={{
            meetingId: "1pm8-gbmc-jfce",
            micEnabled: true,
            webcamEnabled: true,
            name: "Alicia's Org",
        }}
        joinWithoutUserInteraction
        token="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcGlrZXkiOiJmMjY0NjRkZi01YjQ5LTRlMzEtOTg4ZS0xMzg1MDQ3NWE4MGIiLCJwZXJtaXNzaW9ucyI6WyJhbGxvd19qb2luIl0sImlhdCI6MTcyNjA1NjA2MywiZXhwIjoxNzI2MTQyNDYzfQ.rfM9VrD0DwpajCqxrdJWOPw1VF2M_clEKgNQZM9fULQ"
        >
            <ViewerView />
        </MeetingProvider>
    </div>
  );
};

export default StreamViewer;